import { ChatBox, Files, Messages } from '../../components/chat';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getConversationList } from '../../store/chat/chatActions';
import { useParams } from 'react-router';
import { FiChevronLeft } from 'react-icons/fi';
import { Toaster } from 'react-hot-toast';

const Chat = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [defaultChat, setDefalultChat] = useState(null);
    const dispatch = useDispatch();
    const { id } = useParams()
    const [mobileListOpen, setMobileListOpen] = useState(true)

    useEffect(() => {
        setIsLoading(true)
        if (id) {
            setDefalultChat(id)
        } else {
            setDefalultChat(null)
        }
        dispatch(getConversationList())
            .then((v) => {
                setIsLoading(false)
            })
    }, [id, dispatch]);

    return (
        <div>
            <Toaster />
            <div className="relative overflow-hidden flex gap-5">
                <div className={`h-[800px] max-w-[calc(100%-40px)] lg:max-w-none w-[350px] bg-white rounded-xl p-5 shadow-md lg:shadow-none absolute z-10 top-0 lg:relative transition-transform duration-300 ease-linear ${mobileListOpen ? "translate-x-0" : " -translate-x-full"} xl:translate-x-0`}>
                    <button className='lg:hidden absolute bg-white ml-2 h-8 w-8 grid place-items-center rounded-lg shadow-md left-[100%]' onClick={() => setMobileListOpen((x) => !x)}>
                        <FiChevronLeft className={`text-nt-blue right-0 transition-transform delay-150 duration-300 ${!mobileListOpen ? 'rotate-180' : ''}`} />
                    </button>
                    <Messages defaultChat={defaultChat} />
                </div>
                <div className="h-[800px] max-h-screen md:max-h-none bg-white rounded-xl p-5 flex items-center justify-center w-full lg:w-[calc(100%-350px)]">
                    <ChatBox />
                </div>
                <div className="h-[800px] bg-white rounded-xl p-5 w-[350px] hidden lg:block">
                    <Files />
                </div>
            </div>
        </div>
    )
}

export default Chat;